import { API } from "../api/apis";
import  { HttpClient }  from "../../services/api/httpclient.service";


export class CaptureService extends HttpClient {

    constructor() {
        super()
    }

    public async UPLOADIMAGE(formData: FormData, token: string): Promise<any> {
        try {
            const response = await this.post("/capture/upload_image", formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response;
        } catch (error: any) {
          console.error("Image to HTML content API error:", error.response?.data || error.message);
          throw error;
        }
    }

    public async GETVALIDATEEXECISE(sessionId: string) {
      try {
          const response = await this.get(`/capture/get_validate_exercise/${sessionId}`);
          return response; // Ensure to return the response data
      } catch (error: any) {
          console.error('Chosen question API error:', error.response?.data || error.message);
          throw error;
      }
    } 


    public async GENERATETEMPTOKEN(sessionId: string) {
      try {
          const response = await this.get(`/capture/generate-temp-token?session_id=${sessionId}`);
          return response; // Ensure to return the response data
      } catch (error: any) {
          console.error('Chosen question API error:', error.response?.data || error.message);
          throw error;
      }
    } 

    public async markUserImageSolutionActive(sessionId: string, token: string): Promise<any> {
        try {
        const response = await this.post(`/capture/mark_user_image_solution_active/${sessionId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
        } catch (error: any) {
        console.error("Mark solution active API error:", error.response?.data || error.message);
        throw error;
        }
    }

    public async markExerciseActive(sessionId: string, token: string): Promise<any> {
        try {
        const response = await this.post(`/capture/mark_exercise_active/${sessionId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
        } catch (error: any) {
        console.error("Mark exercise active API error:", error.response?.data || error.message);
        throw error;
        }
    }

    public async uploadUserImageSolution(formData: FormData, token: string): Promise<any> {
      try {
        const response = await this.post("/capture/upload_user_image_solution", formData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          }
        });
        return response;
      } catch (error: any) {
        console.error("Upload user image solution API error:", error.response?.data || error.message);
        throw error;
      }
    }

    public async getUserImageSolution(sessionId: string): Promise<any> {
      try {
        const response = await this.get(`/capture/get_user_image_solution/${sessionId}`);
        return response;
      } catch (error: any) {
        console.error("Get user image solution API error:", error.response?.data || error.message);
        throw error;
      }
    }

    public async resetUserImageSolution(sessionId: string): Promise<any> {
      try {
        const response = await this.post(`/capture/reset_user_image_solution/${sessionId}`, {});
        return response;
      } catch (error: any) {
        console.error("Reset user image solution API error:", error.response?.data || error.message);
        throw error;
      }
    }
}